import React from 'react';
import { TeamOutlined, NodeIndexOutlined, AimOutlined, DownOutlined } from '@ant-design/icons';
import { message } from 'antd';

const campaignTypes = [
  {
    id: 'proximity',
    icon: <TeamOutlined />,
    title: 'ProximityIQ + CRM',
    badge: 'Most Popular',
    description: 'Send personalized emails and texts to CRM contacts when your fleet enters their neighborhood.',
  },
  {
    id: 'route',
    icon: <NodeIndexOutlined />,
    title: 'RouteLogic™',
    badge: null,
    description: 'Create digital breadcrumbs along your service routes to target homeowners you pass.',
  },
  {
    id: 'stop',
    icon: <AimOutlined />,
    title: 'StopLogic™',
    badge: null,
    description: "Use job stop locations to reach nearby homeowners in neighborhoods you've serviced.",
  },
];

const ChooseCampaignType = ({ selectedType, onUpdate, onNext }) => {
  const handleSelect = (typeId) => {
    onUpdate(typeId);
  };

  const handleContinue = () => {
    if (!selectedType) {
      message.warning('Please select a campaign type first');
      return;
    }
    onNext();
  };

  return (
    <div className="step-container">
      <h1 className="step-title">Choose Your Campaign Type</h1>
      <p className="step-subtitle">Select the targeting method that fits your strategy</p>

      <div className="campaign-type-grid">
        {campaignTypes.map((type) => (
          <div
            key={type.id}
            className={`campaign-type-card ${selectedType === type.id ? 'selected' : ''}`}
            onClick={() => handleSelect(type.id)}
          >
            <div className="type-icon">
              {type.icon}
            </div>
            <div className="type-title">{type.title}</div>
            {type.badge && (
              <span className="type-badge">{type.badge}</span>
            )}
            <p className="type-description">{type.description}</p>
          </div>
        ))}
      </div>

      {/* Continue Button */}
      <div className="step-actions" style={{ marginTop: 32, textAlign: 'center' }}>
        <button 
          className={`continue-button ${selectedType ? '' : 'disabled'}`}
          onClick={handleContinue}
        >
          Continue
          <DownOutlined />
        </button>
      </div>
    </div>
  );
};

export default ChooseCampaignType;
